import { render, staticRenderFns } from "./ProjectWork.vue?vue&type=template&id=570f4836"
import script from "./ProjectWork.vue?vue&type=script&lang=js"
export * from "./ProjectWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports